import {appConfig} from '@stencil/hotels-config';
import parseDateIntoHermesString from './date-utils/parse-date-into-hermes-string';
import getLocusUrlString from './get-locus-url-string';

const {defaultPartner} = appConfig;

export default function getsemSrpUrl({
  checkin,
  checkout,
  roomString,
  destination,
  partner = defaultPartner,
  overriderankvhids,
  vendor,
  newFilterData,
  newLocationData,
  sort,
}) {
  // const {filter = {}, la = '', lo = ''} = srpConfig;
  const {date: checkinDate} = checkin;
  const {date: checkoutDate} = checkout;
  const {n: destinationCityName = '', _id, xtr = {}, ct = {}, locus = {}} = destination;
  let cityName = destinationCityName;
  let cityId = _id;
  const {cc = 'in'} = xtr; // default as india

  if (xtr && xtr.flt) {
    const {n: voyCityName = '', _id: voyCityId = ''} = ct;
    cityName = voyCityName;
    cityId = voyCityId;
  }

  const hotelQueryString = JSON.stringify({
    ci: parseDateIntoHermesString(checkinDate),
    co: parseDateIntoHermesString(checkoutDate),
    r: roomString,
  });
  const locusUrlStr = getLocusUrlString(locus, true);

  const filterData = (!!newFilterData && `&filterData=${newFilterData}`) || '';
  const locationData = (!!newLocationData && `&locationData=${newLocationData}`) || '';
  const sortApplied = !!sort ? `&sort=${sort}` : '';
  return `/${partner}/find-sem-hotels-in-${cityName}/hotels/${cityId}/${overriderankvhids}/${hotelQueryString}/${locusUrlStr}${filterData}${locationData}${sortApplied}`;
  // return `/${partner}/find-hotels-in-${n}/${_id}/${_id}/${hotelQueryString}/${nQueryString}${sec}`;
}

// https://newprodpp.goibibo.com/hotels/find-sem-hotels-in-Kanyakumari/anantya-resorts-90-minutes-from-kanyakumari/4049791448359331848/1813165773764248779/?hquery={%22d%22:{%22k%22:7,%22l%22:%202},%22r%22:%221-2-0%22,%22ibp%22:%22v3%22}&campaign=Domestic_Hotel_Name_TROAS_Test_3
